/* eslint-disable object-curly-newline */
import React from 'react';
import PropTypes from 'prop-types';

import DesertSvg from './media/desert.svg';

export const EmptyView = ({ i18n, isInSubfolder, isFilterSet }) => {
  let str = i18n.getString(_TL_("You haven't added any assets yet. Once you add assets to an ad, you'll see them here. "));
  if (isFilterSet) {
    str = i18n.getString(_TL_('No assets match your search. Please try again.'));
  } else if (isInSubfolder) {
    str = i18n.getString(_TL_('There are no assets in this folder. You can add existing assets or upload new assets and move them here.'));
  }
  return (
    <div className="empty-view-container">
      <img src={DesertSvg} alt="desert" />
      <div className="empty-view-title">{i18n.getString(_TL_('Nothing to see here'))}</div>
      <div className="empty-view-desc">{str}</div>
    </div>
  );
};

EmptyView.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  isInSubfolder: PropTypes.bool,
  isFilterSet: PropTypes.bool,
};

EmptyView.defaultProps = {
  isInSubfolder: false,
  isFilterSet: false,
};
